/**
 * Trader portal shell. Same bar, same rail, fewer modules — continuity across
 * portals is a brand rule, not a shortcut. "Become an IB" turns into
 * "Partner area" once the trader is approved as one.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/useAuth";
import { useFilteredTraderNav } from "@/hooks/useEnabledNav";
import { PortalShell } from "./PortalShell";
import { ShellSkeleton } from "./ShellSkeleton";
import { TRADER_SECTIONS } from "./navSections";

export function TraderShell() {
  const { data: me, isPending, isError } = useMe();
  const location = useLocation();
  const traderNav = useFilteredTraderNav();

  if (isPending) return <ShellSkeleton items={8} />;
  if (isError || !me) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  // Raw traders and IBs (dual trader+IB profiles) both belong here; admins and
  // platform admins have their own shells.
  if (me.role !== "trader" && me.role !== "ib" && me.role !== "affiliate") {
    if (me.role === "platform_admin") return <Navigate to="/platform/dashboard" replace />;
    if (me.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  const isIb = me.role === "ib" || me.isIb;
  const nav = traderNav.map((item) =>
    isIb && item.to === "/trader/become-ib"
      ? { ...item, label: "Partner Area", to: "/ib/dashboard" }
      : item,
  );

  return <PortalShell nav={nav} sections={TRADER_SECTIONS} supportTo="/trader/support" />;
}
